<template>
  <div class="view pa24">
    <el-dialog
        :title="title"
        width="80%"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :before-close="closeDialog"
    >
     <div class="dialogBody">
      <commonTable
          :tableData="tableData"
          :total="total"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
        <template v-slot:table>
          <el-table-column
              prop="handle"
              align="center"
              label="商品码"
            />

            <el-table-column
              prop="title"
              align="center"
              label="商品名称"
            />
            <el-table-column
              prop="company"
              align="center"
              label="企业名称"
            />
          <el-table-column
              prop="brand"
              align="center"
              label="品牌名称"
          />
          <el-table-column
              prop="phone"
              align="center"
              label="手机号码"
          />
          <el-table-column
              prop="content"
              align="center"
              label="反馈内容"
          />
          <el-table-column
              prop="type"
              align="center"
              label="反馈类型"
          />
          <el-table-column
              prop="channel"
              align="center"
              label="购买渠道"
          >
            <template slot-scope="scope">
              {{ 0===scope.row.channel ? '线上':'线下'}}
            </template>
          </el-table-column>
          <el-table-column
              prop="platform"
              align="center"
              label="平台"
          />
          <el-table-column
              prop="shop"
              align="center"
              label="店铺名称"
          />
          <el-table-column align="center" label="线下地址">
            <template slot-scope="scope">
              {{scope.row.province}}{{ scope.row.city}}{{ scope.row.county}}
            </template>
          </el-table-column>

          <el-table-column align="center" label="凭证">
            <template slot-scope="scope">
              <div v-for="(item,index) in scope.row.images" :key="index">
                <el-image :preview-src-list="[item]" style="width: 60px;" :src="item"></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="createTime"
              align="center"
              label="反馈时间"
          />
        </template>
      </commonTable>
     </div>
    </el-dialog>
  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { feedbackLog } from '@/api/customPage.js'
export default {
  name: "logFeedBackDialog",
  data() {
    return {
      dialogVisible: false,
      title: '标识反馈记录',
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1
    };
  },
  components: {
    commonTable
  },
  onShow() {

  },
  methods: {
    openDialog() {
      this.getList()
    },
    closeDialog() {
      this.dialogVisible = false
    },
    getList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      feedbackLog(params).then(res => {
        if(res.code == 200) {
          var list = res.data.list
          for(var i=0; i<list.length; i++){
            if( ''===list[i].certificate || null ===list[i].certificate ){
              list[i].images = []
            }else{
              list[i].images = JSON.parse(list[i].certificate)
            }
          }
          this.tableData = list
          this.total = res.data.total
          this.dialogVisible = true
        }
      })
    },
    handleSizeChange(num) {
      this.pageSize = num;
      this.pageNum = 1;
      this.getList();
    },
    handleCurrentChange(num) {
      this.pageNum = num;
      this.getList();
    }
  }
}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10 rpx;
}
.dialogBody{
  //max-height: 60vh;
  //overflow-y: scroll;
}
</style>
